import { Select, Skeleton } from "antd";
import Container from "../../../General/Container/Container";
import { TeamOutlined, UserOutlined } from "@ant-design/icons";

function WhiteSpaceSummaryTextDisplay({
    text = "",
    title = "",
    list = [],
    selectedMicrosegment = {},
    onChange = () => { },
    loading
}) {
    return <Container className="whitespace-summarywithtext-item dcol flex-1 gap-2">
        <span className="whitespace-summarywithtext-title">{title}</span>
        <Container className="dcol gap-5p">
            <Container className="drow align-center gap-5p">
                <UserOutlined />
                <span className="whitespace-summarywithtext-label">Microsegment:</span>
                <Select
                    popupClassName="whitespace-summarywithtext-value"
                    className="whitespace-summarywithtext-value"
                    disabled={loading}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => (option?.label ?? "").includes(input)}
                    options={[{
                        value: "general",
                        label: "General"
                    }, ...list.map(({ name }) => ({
                        value: name,
                        label: name
                    }))]}
                    value={selectedMicrosegment.value}
                    onChange={onChange}
                />
            </Container>
            <Container className="drow align-center gap-5p">
                <TeamOutlined />
                <span className="whitespace-summarywithtext-label">Size:</span>
                <span className="whitespace-summarywithtext-value">{
                    selectedMicrosegment.newFormulaScore
                        ? (selectedMicrosegment.newFormulaScore).toFixed(2) + "%"
                        : "-"
                }</span>
            </Container>
        </Container>
        <Container className="flex-1" style={{ whiteSpace: "pre-wrap" }}>
            {loading
                ? <Skeleton paragraph={{ rows: 6 }} active />
                : text}
        </Container>
    </Container>
}

export default WhiteSpaceSummaryTextDisplay;
